module.exports = __webpack_public_path__ + "img/browser4.0152c108.png";